module.exports = __webpack_public_path__ + "static/media/hd-pg1.44c8a0c1.jpg";